import { BASE_URL } from "../config/api";

export const createMarquee = async (marqueeData) => {
  const token = localStorage.getItem("token");

  const response = await fetch(`${BASE_URL}/marquee/createMarquee`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(marqueeData),
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.message || "Failed to create marquee.");
  }

  return result;
};

export const updateMarquee = async (id, marqueeData) => {
  const token = localStorage.getItem("token");

  const response = await fetch(`${BASE_URL}/marquee/updateMarquee/${id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(marqueeData),
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.message || "Failed to update marquee.");
  }

  return result;
};

export const fetchAllMarquee = async () => {
  const response = await fetch(`${BASE_URL}/marquee/fetchAllMarquee`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to fetch marquees");
  }

  const data = await response.json();
  return data.marquees;
};

export const fetchMarqueeById = async (id) => {
  const response = await fetch(`${BASE_URL}/marquee/fetchMarqueeById/${id}`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to fetch marquee");
  }

  const data = await response.json();
  return data.marquee;
};

export const deleteMarquee = async (id) => {
  const token = localStorage.getItem("token");

  const response = await fetch(`${BASE_URL}/marquee/deleteMarquee/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.message || "Failed to delete marquee.");
  }

  return result;
};